import { render } from "./EditTranslationTable.vue?vue&type=template&id=101823a2&scoped=true"
import script from "./EditTranslationTable.vue?vue&type=script&lang=js"
export * from "./EditTranslationTable.vue?vue&type=script&lang=js"

import "./edit-translation-table.scss?vue&type=style&index=0&id=101823a2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101823a2"]])

export default __exports__